import { Box, Button, Grid2, Typography } from "@mui/material";
import React, { useState, useEffect, useRef } from 'react';
import { commonCss } from "../StyleConfig/CommonCss";

const Confirmation = ({name, onSubmit, handleCloseClick}) => {
  const [focusedButton, setFocusedButton] = useState('yes'); 
  const [isSubmitting, setIsSubmitting] = useState(false); // Add this state
  const yesButtonRef = useRef(null);
  const noButtonRef = useRef(null);

  useEffect(() => {
    if (yesButtonRef.current) {
      yesButtonRef.current.focus();
    }
  }, []);

  const handleSubmit = () => {
    if (isSubmitting) return; // Prevent multiple submissions
    setIsSubmitting(true);
    onSubmit(); // Assuming onSubmit is a promise or has a callback
    // If onSubmit is not a promise, you might need to handle completion differently
  };

  const handleKeyDown = (e) => {
    switch (e.key) {
      case 'ArrowLeft':
        setFocusedButton('yes');
        yesButtonRef.current?.focus();
        break;
      case 'ArrowRight':
        setFocusedButton('no');
        noButtonRef.current?.focus();
        break;
      case 'Enter':
        e.preventDefault(); 
        if (focusedButton === 'yes') {
          handleSubmit(); // Use the new handleSubmit instead of onSubmit directly
        } else {
          handleCloseClick();
        }
        break;
      default:
        break;
    }
  };

  return (
    <Grid2 container onKeyDown={handleKeyDown} tabIndex={-1}>
      <Grid2 size={12} container justifyContent={"center"}>
        <Typography
          fontWeight={400}
          color={"white"}
          sx={{ fontSize: "1rem" }}
        >
          Are you sure you want to {name}?
        </Typography>
      </Grid2>
      <Grid2 size={12} container justifyContent={"center"}>
        <Box 
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "0.6rem"
          }}
        >
          <Button
            ref={yesButtonRef}
            type="button"
            variant="contained"
            disabled={isSubmitting} // Disable button when submitting
            sx={{
              backgroundColor: focusedButton === 'yes' ? commonCss.green : commonCss.green,
              borderRadius: commonCss.buttonBorderRadius,
              textTransform: "none",
              padding: "0.6rem 1rem",
              color: commonCss.buttonTextColor,
              '&:focus': {
                outline: '2px solid #fff',
                outlineOffset: '2px'
              },
              '&:disabled': {
                opacity: 0.7,
                cursor: 'not-allowed'
              }
            }}
            onClick={handleSubmit} // Use the new handleSubmit
            onFocus={() => setFocusedButton('yes')}
            onKeyDown={(e) => e.key === 'Enter' && e.preventDefault()}
          >
            {isSubmitting ? 'Processing...' : 'Yes'}
          </Button>
          <Button
            ref={noButtonRef}
            type="button"
            variant="contained"
            sx={{
              backgroundColor: focusedButton === 'no' ? commonCss.green : commonCss.green,
              borderRadius: commonCss.buttonBorderRadius,
              textTransform: "none",
              padding: "0.6rem 1rem",
              color: commonCss.buttonTextColor,
              '&:focus': {
                outline: '2px solid #fff',
                outlineOffset: '2px'
              }
            }}
            onClick={handleCloseClick}
            onFocus={() => setFocusedButton('no')}
            onKeyDown={(e) => e.key === 'Enter' && e.preventDefault()}
          >
            No
          </Button>
        </Box>
      </Grid2>
    </Grid2>
  );
};

export default Confirmation;